import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editContent } from "../../modules/editor";
import produce from 'immer';
import { RootState } from '../../modules';

import FieldSection from './FieldSection';
import SelectedContentLayout from './SelectedContentLayout';
import { defaultContent } from '../../config/components';
import useAlert from '../../hooks/useAlert';

type Props = {
	selectedContentId: number;
	currentContent:any;
}

function SelectedContentBase({ selectedContentId, currentContent }: Props) {
	const dispatch = useDispatch();
	const Alert = useAlert();

	const commonStyle = useSelector((state: RootState) => state.editor.container.commonStyle);

	const onChangeColumnCount = (count:number) => {

		if (count === currentContent?.content?.column?.length) {
			return;
		}

		let newColumn: any;

		if (count === 1) {
			Alert.confirm(Alert?.msg?.COLUMN_REMOVE_2ND, () => {
				newColumn = produce(currentContent?.content?.column, (draft: any) => {
					draft.splice(1,1);
				});
				dispatch(editContent({ target: `${selectedContentId}/column`, data: newColumn }));
			})
		}	else if(count === 2) {
			newColumn = produce(currentContent?.content?.column, (draft: any) => {
				draft.push(draft[0]);
			});
			
			let newContent = produce(currentContent?.content?.content, (draft:any) => {
				draft[1] = {...defaultContent};
			})
			
			let newStyle = produce(currentContent?.content?.style, (draft: any) => {
				draft[1] = JSON.parse(JSON.stringify(draft[0]));
			});

			dispatch(editContent({ target: `${selectedContentId}/style`, data: newStyle }));
			dispatch(editContent({ target: `${selectedContentId}/content`, data: newContent }));
			dispatch(editContent({ target: `${selectedContentId}/column`, data: newColumn }));
		}		
	}

	return (
		<div className="editor-sidebar-selected-content-setting">
			{
				currentContent?.content?.type !== 'cntB' ? (
					<>
					<h3 className="field-section-title">레이아웃</h3>
					<FieldSection
						labelName=""
						label={false}
						fullWidth={true}
					>
						<div className="layout-field">
							<button className={currentContent?.content?.column?.length === 1 ? 'btn medium primary-black' : 'btn medium line tertiary'} onClick={() => {onChangeColumnCount(1)}}>1단</button>
							<button className={currentContent?.content?.column?.length === 2 ? 'btn medium primary-black' : 'btn medium line tertiary'} onClick={() => {onChangeColumnCount(2)}}>2단</button>
						</div>
					</FieldSection>
					<SelectedContentLayout isCnt={false} />
					</>
				) : (
					<div>
						<SelectedContentLayout isCnt={true} />
					</div>
				)
			}
		</div>
	);
}

export default SelectedContentBase;